import React, {useEffect, useRef} from 'react';
import FormInput from "../../formComponents/FormInput";
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import {getFullName} from "../../utils/PersonNameUtil";
import FormLinkedItemSelect from "../../formComponents/FormLinkedItemSelect";
import FormLinkedItemSimpleSelect from "../../formComponents/FormLinkedItemSimpleSelect";
import {allArtistRoles, allSchoolClasses} from "../../data/Enums";

const LiteraryWorksItemForm = ({initData, controlRef}) => {

    const controlRefName = useRef(null);
    const controlRefAuthor = useRef(null);
    const controlRefSchoolClass = useRef(null);

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать название!"))
            isValid = false;

        if (!controlRefName.current.validateLength(255))
            isValid = false;

        if (!controlRefAuthor.current.validateIsSelected("Нужно выбрать автора!"))
            isValid = false;

        if (!controlRefSchoolClass.current.validateIsSelected("Нужно выбрать школьный класс или '(нет в ШП)'!"))
            isValid = false;

        return isValid;
    }

    function getData() {
        const schoolClassId = controlRefSchoolClass.current.getSelectedId();

        return {
            name: controlRefName.current.getText(),
            author_id: controlRefAuthor.current.getSelectedId(),
            school_program_class: schoolClassId === 0 ? null : schoolClassId,
        }
    }

    function renderInitialArtistItemExtraInfo(item, className) {
        return <span className={className}>{getInitialArtistMainRoleName(item.id)}</span>
    }

    function getInitialArtistMainRoleName(artistId) {
        const artist = initData?.refs?.authors?.[artistId];
        if (!artist)
            return "?";

        return allArtistRoles.find(x => x.id === artist.main_role)?.name ?? "?";
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock title="Основные">
                <FormInput
                    controlRef={controlRefName}
                    label="Название"
                    widthLimit={500}
                    initValue={initData?.name ?? ""}
                />
                <FormLinkedItemSelect
                    controlRef={controlRefAuthor}
                    label="Автор"
                    widthLimit={500}
                    initSelectedId={initData?.author_id}
                    specialOptions={[{id: null, name: "(без автора)"}]}
                    initRefList={initData?.refs?.authors}
                    apiName2="artists"
                    showIds={true}
                    itemNameFunc={item => getFullName(item.first_name, item.last_name, item.middle_name)}
                    tipText={"Если автор неизвестен или это народное произведение, выберите вариант '(без\u00A0автора)'."}
                    renderItemExtraInfoFunc={renderArtistItemExtraInfo}
                    renderInitialItemExtraInfoFunc={renderInitialArtistItemExtraInfo}
                />
                <FormLinkedItemSimpleSelect
                    controlRef={controlRefSchoolClass}
                    label="Школьный класс"
                    widthLimit={150}
                    initSelectedId={!initData ? undefined : (initData.school_program_class ?? 0)}
                    options={schoolClasses}
                    tipText={"Укажите школьный класс, если данное произведение есть в школьной программе.\nИначе, выберите '(нет в ШП)'."}
                />
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

function renderArtistItemExtraInfo(item, className, dataRefs) {
    if (!item.main_role)
        return null;

    return <span className={className}>{allArtistRoles.find(x => x.id === item.main_role)?.name ?? "?"}</span>
}

const schoolClasses = [{id: 0, name: "(нет в ШП)"}, ...allSchoolClasses]

export default LiteraryWorksItemForm;